export enum Field {
  FullName = 'fullName',
  FirstName = 'firstName',
  LastName = 'lastName',
  Birthdate = 'birthdate',
  SsnNumber = 'ssn',
  PersonalIdNumber = 'personalIdNumber',
  Nationality = 'nationality',
  Address = 'address',
  PepType = 'pepType',
  PepFullName = 'pepFullName',
  PepPosition = 'pepPosition',
  PepOrganisation = 'pepOrganisation',
  PepPositionDate = 'pepPositionDate',
}
